import React from 'react';
import type { GridProps } from 'react-native-svg-charts';

export type { GridProps };

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Grid = <T,>(_: GridProps<T>) => {
  return <React.Fragment key="grid-fragment"></React.Fragment>;
};
